package org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_product_general.chat_model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlinx.serialization.json.JsonElement

@Serializable
sealed class StepDetailsModel {
    @Serializable
    @SerialName("Generate")
    data class Generate(
        val total_tokens_spent: Long,
        val status: String,
        val time_spent_sec: Double
    ) : StepDetailsModel()
    @Serializable
    @SerialName("Request")
    data class Request(
        val model: String,
        val status: String,
        val time_spent_sec: Double
    ) : StepDetailsModel()
    @Serializable
    @SerialName("FunctionCalling")
    data class FunctionCalling(
        val name: String,
        val arguments: Map<String, JsonElement>,
        val weight: Float?,
        val lambda_seconds: Double?,
        val data_size_bytes: Long?,
        val file_count: Int?,
        val is_premium: Boolean?,
        val status: String,
        val time_spent_sec: Double
    ) : StepDetailsModel()
}